// Original assets and ordering from https://www.devclub.com.br/
// Synced from the institutional site on 2026-10-02; no logos are recreated.
export const employerLogos = [
  {
    name: 'iFood',
    file: 'ifood.svg',
    scale: 0.9,
  },
  {
    name: 'Santander',
    file: 'santander.svg',
    scale: 1,
  },
  {
    name: 'IBM',
    file: 'ibm.svg',
    scale: 0.8,
  },
  {
    name: 'Bradesco',
    file: 'bradesco.svg',
    scale: 1,
  },
  {
    name: 'Accenture',
    file: 'accenture.svg',
    scale: 1,
  },
  {
    name: 'Burger King',
    file: 'burgerking.svg',
    scale: 1.15,
  },
  {
    name: 'Vivo',
    file: 'vivo.svg',
    scale: 0.95,
  },
  {
    name: 'Stone',
    file: 'stone.svg',
    scale: 1,
  },
  {
    name: 'TOTVS',
    file: 'totvs.svg',
    scale: 1,
  },
  {
    name: 'Lojas Renner',
    file: 'renner.svg',
    scale: 0.95,
  },
  {
    name: 'UOL',
    file: 'uol.svg',
    scale: 0.95,
  },
  {
    name: 'Unimed',
    file: 'unimed.svg',
    scale: 1,
  },
  {
    name: 'Hospital Albert Einstein',
    file: 'einstein.svg',
    scale: 1.55,
  },
  {
    name: 'CVC',
    file: 'cvc.svg',
    scale: 0.85,
  },
  {
    name: 'PagBank',
    file: 'pagbank.svg',
    scale: 1,
  },
  {
    name: 'EBANX',
    file: 'ebanx.svg',
    scale: 1,
  },
  {
    name: 'CCR',
    file: 'ccr.svg',
    scale: 1.25,
  },
  {
    name: 'SKY',
    file: 'sky.svg',
    scale: 0.9,
  },
  {
    name: 'Wipro',
    file: 'wipro.svg',
    scale: 1.3,
  },
  {
    name: 'Algar',
    file: 'algar.svg',
    scale: 1,
  },
  {
    name: 'Raia Drogasil',
    file: 'raiadrogasil.svg',
    scale: 1,
  },
  {
    name: 'PUC',
    file: 'puc.png',
    scale: 1.2,
  },
  {
    name: 'Forças Armadas',
    file: 'forcas-armadas.svg',
    scale: 1.6,
  },
  {
    name: 'GFT',
    file: 'gft.svg',
    scale: 0.9,
  },
  {
    name: 'Avanade',
    file: 'avanade.svg',
    scale: 1,
  },
  {
    name: 'MJV',
    file: 'mjv.svg',
    scale: 0.7,
  },
  {
    name: 'Valeo',
    file: 'valeo.svg',
    scale: 0.85,
  },
  {
    name: 'Senac',
    file: 'senac.svg',
    scale: 1.1,
  },
  {
    name: 'Sonda Supermercados',
    file: 'sonda.png',
    scale: 1.15,
  },
] as const;
